import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-services',
  templateUrl: './security-services.component.html',
  styleUrls: ['./security-services.component.scss']
})
export class SecurityServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
